export const amcList = {
  amcs: [
    {
      amc_name: "Taurus Mutual Fund",
      amc_id: "53",
      icon: require("./../assets/images/amc/53.png"),
    },
    {
      amc_name: "ICICI Prudential Mutual Fund",
      amc_id: "56",
      icon: require("./../assets/images/amc/56.png"),
    },
    {
      amc_name: "Principal Mutual Fund",
      amc_id: "57",
      icon: require("./../assets/images/amc/57.png"),
    },
    {
      amc_name: "DSP Mutual Fund",
      amc_id: "59",
      icon: require("./../assets/images/amc/59.png"),
    },
    {
      amc_name: "L&T Mutual Fund",
      amc_id: "61",
      icon: require("./../assets/images/amc/61.png"),
    },
    {
      amc_name: "Sahara Mutual Fund",
      amc_id: "62",
      icon: require("./../assets/images/amc/62.png"),
    },
    {
      amc_name: "Sundaram Mutual Fund",
      amc_id: "63",
      icon: require("./../assets/images/amc/63.png"),
    },
    {
      amc_name: "JM Financial Mutual Fund",
      amc_id: "64",
      icon: require("./../assets/images/amc/64.png"),
    },
    {
      amc_name: "LIC Mutual Fund",
      amc_id: "67",
      icon: require("./../assets/images/amc/67.png"),
    },
    {
      amc_name: "Kotak Mahindra Mutual Fund",
      amc_id: "68",
      icon: require("./../assets/images/amc/68.png"),
    },
    {
      amc_name: "ING Vysya Mutual Fund",
      amc_id: "71",
      icon: require("./../assets/images/amc/71.png"),
    },
    {
      amc_name: "Nippon India Mutual Fund",
      amc_id: "73",
      icon: require("./../assets/images/amc/73.png"),
    },
    {
      amc_name: "SBI Mutual Fund",
      amc_id: "75",
      icon: require("./../assets/images/amc/75.png"),
    },
    {
      amc_name: "Shriram Mutual Fund",
      amc_id: "76",
      icon: require("./../assets/images/amc/76.png"),
    },
    {
      amc_name: "Tata Mutual Fund",
      amc_id: "77",
      icon: require("./../assets/images/amc/77.png"),
    },
    {
      amc_name: "Franklin Templeton Mutual Fund",
      amc_id: "78",
      icon: require("./../assets/images/amc/78.png"),
    },
    {
      amc_name: "IDFC Mutual Fund",
      amc_id: "80",
      icon: require("./../assets/images/amc/80.png"),
    },
    {
      amc_name: "HDFC Mutual Fund",
      amc_id: "82",
      icon: require("./../assets/images/amc/82.png"),
    },

    {
      amc_name: "HSBC Mutual Fund",
      amc_id: "84",
      icon: require("./../assets/images/amc/84.png"),
    },
    {
      amc_name: "PGIM India Mutual Fund",
      amc_id: "85",
      icon: require("./../assets/images/amc/85.png"),
    },
    {
      amc_name: "UTI Mutual Fund",
      amc_id: "86",
      icon: require("./../assets/images/amc/86.png"),
    },
    {
      amc_name: "BNP Paribas Mutual Fund",
      amc_id: "87",
      icon: require("./../assets/images/amc/87.png"),
    },
    {
      amc_name: "L&T Mutual Fund",
      amc_id: "88",
      icon: require("./../assets/images/amc/88.png"),
    },
    {
      amc_name: "Quantum Mutual Fund",
      amc_id: "89",
      icon: require("./../assets/images/amc/89.png"),
    },
    {
      amc_name: "Invesco Mutual Fund",
      amc_id: "90",
      icon: require("./../assets/images/amc/90.png"),
    },
    {
      amc_name: "JPMorgan Mutual Fund",
      amc_id: "91",
      icon: require("./../assets/images/amc/91.png"),
    },

    {
      amc_name: "Mirae Asset Mutual Fund",
      amc_id: "93",
      icon: require("./../assets/images/amc/93.png"),
    },
    {
      amc_name: "BOI AXA Mutual Fund",
      amc_id: "94",
      icon: require("./../assets/images/amc/94.png"),
    },
    {
      amc_name: "Edelweiss Mutual Fund",
      amc_id: "95",
      icon: require("./../assets/images/amc/95.png"),
    },
    {
      amc_name: "SBI Mutual Fund",
      amc_id: "96",
      icon: require("./../assets/images/amc/96.png"),
    },
    {
      amc_name: "Aditya Birla Sun Life Mutual Fund",
      amc_id: "97",
      icon: require("./../assets/images/amc/97.png"),
    },
    {
      amc_name: "Baroda Mutual Fund",
      amc_id: "98",
      icon: require("./../assets/images/amc/98.png"),
    },
    {
      amc_name: "Canara Robeco Mutual Fund",
      amc_id: "100",
      icon: require("./../assets/images/amc/100.png"),
    },
    {
      amc_name: "Axis Mutual Fund",
      amc_id: "101",
      icon: require("./../assets/images/amc/101.png"),
    },
    {
      amc_name: "Navi Mutual Fund",
      amc_id: "102",
      icon: require("./../assets/images/amc/102.png"),
    },
    {
      amc_name: "IDBI Mutual Fund",
      amc_id: "110",
      icon: require("./../assets/images/amc/110.png"),
    },
    {
      amc_name: "Motilal Oswal Mutual Fund",
      amc_id: "111",
      icon: require("./../assets/images/amc/111.png"),
    },

    {
      amc_name: "Indiabulls Mutual Fund",
      amc_id: "115",
      icon: require("./../assets/images/amc/115.png"),
    },
    {
      amc_name: "PPFAS Mutual Fund",
      amc_id: "138",
      icon: require("./../assets/images/amc/138.png"),
    },
    {
      amc_name: "Mahindra Manulife Mutual Fund",
      amc_id: "141",
      icon: require("./../assets/images/amc/141.png"),
    },
    {
      amc_name: "YES Mutual Fund",
      amc_id: "142",
      icon: require("./../assets/images/amc/142.png"),
    },
    {
      amc_name: "ITI Mutual Fund",
      amc_id: "143",
      icon: require("./../assets/images/amc/143.png"),
    },
    {
      amc_name: "Trust Mutual Fund",
      amc_id: "146",
      icon: require("./../assets/images/amc/146.png"),
    },
  ],
};
